// extracted by mini-css-extract-plugin
export default {"App":"app_App__sgUHC","App-logo":"app_App-logo__3pcho","App-logo-spin":"app_App-logo-spin__7xA5h","App-header":"app_App-header__FPuby","App-link":"app_App-link__tUYbh"};